import S51WebGLSDK from "../S51WebGLSDK";
import { BUS_EVENT, EventBus } from "../eventBus";

 class AudioQueue {
    constructor(){
        this.audioText = new Audio()
        this.audioList=[]
        this.audioRead =0
        this.type=0; //0-2D 1-3D需要驱动口型
        this.start=0;
        this.muted=true;//默认静音
        this.audioID = 0
        this.audioPlaying=false
        let _this = this
        this.audioCtx = new (window.AudioContext || window.webkitAudioContext)(); 
        let playEndHandler =()=>{
            console.log('-=-=-=-=-=-= end')
            if(_this.audioRead<_this.audioList.length){
                if(_this.audioList[_this.audioRead].endFlag){
                    _this.callback && _this.callback('endPlay',{id:_this.audioID})
                    _this.type ==AudioDriveType.TYPE_3D &&  S51WebGLSDK.setJWAOpenValue(0)
                    _this.audioPlaying=false
                }
                _this.audioList[_this.audioRead].audioState = 2 //播放结束，开始下一个 
                _this.audioRead++
                _this.nextAudio()
                console.log('语音播放结束，播放下一个语音:')
            }
          }
          this.audioText.addEventListener('ended',playEndHandler)
    }
    setEventListener(callback){
        this.callback = callback
    }
    setMuted(muted){
       
        if(!muted && this.muted){ //取消静音，并且之前是静音状态开始播放
            this.audioCtx && this.audioCtx.resume() //激活audioctx
            this.audioText.muted=false
            this.nextAudio()
            if(this.timeHandler) clearInterval(this.timeHandler)
            this.timeHandler= setInterval(()=>{
                this.nextAudio()
            },200)
           
        }
        this.muted = muted
    }
    reset(type){
        if(type){
            this.type=type
        }
        if(this.audioPlaying){
            this.pause()    
        }
        
        this.audioList=[]
        this.audioRead=0    
        console.log('muted state',this.muted)
        if(!this.muted){ //非静音状态，开始播放列表
            if(this.timeHandler) clearInterval(this.timeHandler)
            this.timeHandler= setInterval(()=>{
                this.nextAudio()
            },200) 
            this.audioCtx && this.audioCtx.resume() //激活audioctx
        }
        else{ //当前静音状态

        }
        
       
        
    }
    addAudio(url,uniID,endFlag){
        console.log('add url',url)
        this.audioList.push({
            audio:url,
            audioState:0,
            endFlag:endFlag?true:false,
        })
        if(this.audioList.length==1){ //第一条记录 记录开始时间
            this.start = Date.now()
            this.audioID = uniID
            this.callback && this.callback('startLoading',{id:this.audioID})
        }
    }
    pause(){
 
        this.audioText.pause()
        this.audioCtxPlaying=false
        S51WebGLSDK.setJWAOpenValue(0)
        this.audioCtx && this.audioCtx.suspend()
        this._source && (this._source.onended=null)
        this._source=null
        console.log('播放结束 pause')

    }
    /**
       * 处理下一帧文字
       * 返回： true:所有消息结束 false:消息未结束
       */
    nextAudio(){
        if(this.audioRead>=this.audioList.length){
          return
        }
        
        if(!this.audioList[this.audioRead].audioState || this.audioList[this.audioRead].audioState==0){ //0-还未开始 1-播放中 2-播放结束
          if(this.audioList[this.audioRead].audio){
           
              this.audioText.autoplay=false
              this.audioText.src=this.audioList[this.audioRead].audio
              this.audioText.muted=false
              this.audioPlaying=true
              let _this =this
              
              if(this.audioRead == 0){ //第一个音频 如果当前时间-开始时间没有超过第一个音频的时长，则使用seek到指定位置
                let startPlayHandler= function(){
                   
                    _this.audioText.removeEventListener('canplaythrough',startPlayHandler)
                    let curTime = (Date.now()  - _this.start-200)*1.0/1000
                    console.log('start play handler',_this.audioText.duration,curTime)
                    if(curTime<1){
                        curTime=0 //1秒以内不seek
                    }
                    if(_this.audioText.duration<=curTime){ //已经超时 播放结束
                        _this.audioText.pause()
                        return;
                    }
                    _this.audioText.currentTime = curTime
                    
                    let seeked =function(){
                        console.log('seeked handler')
                        _this.audioText.removeEventListener('seeked',seeked)
                        _this.audioText.muted=false
                        _this.audioText.play().then(()=>{
                            _this.callback && _this.callback('startPlay',{id:_this.audioID})
                        },err=>{
                            //  alert(err)
                            console.error(err)
                        })
                    }
                    _this.audioText.addEventListener('seeked',seeked)
                    // console.log('type',_this.type)
                    _this.type==AudioDriveType.TYPE_3D && _this.initAudioCtx(_this.audioList[_this.audioRead].audio,_this.audioText.currentTime+0.1)
                }
                this.audioText.addEventListener('canplaythrough',startPlayHandler)
                this.audioText.muted=true //开始播放前静音，等加载完成后再开始播放声音
                this.audioText.load()  
                console.log('load audio')
              }
              else{
                this.audioText.play().then(()=>{},err=>{
                    //  alert(err)
                    console.error(err)
                })
                this.type==AudioDriveType.TYPE_3D &&  this.initAudioCtx(this.audioList[this.audioRead].audio,0.1)
              }
              
             
              this.audioList[this.audioRead].audioState=1
              console.log('开始播放语音:',this.audioList[this.audioRead].audio)

          }
          else{
            console.log('没有语音文件',this.audioList[this.audioRead])
            this.audioList[this.audioRead].audioState=2
            if(this.audioList[this.audioRead].endFlag){ //最后一个语音 
                this.callback && this.callback('endPlay',{id:this.audioID})
                this.type ==AudioDriveType.TYPE_3D &&  S51WebGLSDK.setJWAOpenValue(0)
                this.audioPlaying=false
            }
            this.audioRead++
            this.nextAudio()
          }
        
        }
      }
       /**
     * 根据音频波形控制口行张合
     */
    initAudioCtx(audioUrl,startSec){
        // console.log('init audio ctx',audioUrl,startSec)
        let _sensitivityThreshold = .5;   
        const samplingFrequency = 44100;
        const _voiceBoundingFrequencies = [0, 500, 700, 3000, 6000];
        const _audioSampleCount = {low:256, med:512, high:1024};
        let _smoothing = 0.5; 
        const getstPSD = spectrum => {

           const stPSD = new Float32Array(spectrum.length);
   
           for (let i = 0 ; i< spectrum.length;i++) {
               stPSD[i]= _sensitivityThreshold + ((spectrum[i] +20)/140);	
           }
           
           return stPSD;
        }
        
       const _getData = url => {
           var request = new XMLHttpRequest();

           request.open('GET', url, true);
           request.responseType = 'arraybuffer';

           return new Promise(function (resolve, reject) {
               request.onload = function() {
                   var audioData = request.response;
                   resolve(audioData);
                   console.log('audioData',audioData)
                }

                request.send();
           });
       }

        let _sampleCount = _audioSampleCount.high;
        let _indicesFrequencyMale = [];
        let _analyser = this.audioCtx.createAnalyser();     
        this.audioCtxPlaying=false
        let _this = this
        _getData(audioUrl).then(audioData=>{
            _this.audioCtx.decodeAudioData(audioData, function(_buffer) {
                console.log('Buffer ready to play.');
               for( let m = 0 ; m < _voiceBoundingFrequencies.length ; m++) {
                   _indicesFrequencyMale[m] = Math.round(((2*_sampleCount)/samplingFrequency) *_voiceBoundingFrequencies[m]);
                   //console.log("IndicesFrequencyMale[",m,"]",_indicesFrequencyMale[m]);
               }
               _analyser.minDecibels = -160;
               _analyser.maxDecibels = -25;
               _analyser.smoothingTimeConstant = _smoothing;
               _analyser.fftSize = _sampleCount;
               
               _this._source = _this.audioCtx.createBufferSource()
               _this._source.buffer = _buffer;
               _this._source.connect(_analyser);
               const gainNode = _this.audioCtx.createGain();
               gainNode.connect(_this.audioCtx.destination);
               gainNode.gain.value = 0; // 设置音量为0
               _this._source.connect(gainNode)
               if(_this._node){
                _this._node.onaudioprocess=null
                _this._node = null
               }
               _this._node = _this.audioCtx.createScriptProcessor(_sampleCount*2, 1, 1);
               _analyser.connect(_this._node);
               _this._node.onaudioprocess = _ => {
                    if(!_this.audioCtxPlaying) return
                   // console.log('=============== process')
                   let _spectrum = new Float32Array(_analyser.frequencyBinCount);
                   _analyser.getFloatFrequencyData(_spectrum);
                   let _stPSD = getstPSD(_spectrum);
                   
                   let _blendShapeKiss = 0;
                   let _blendShapeLips = 0;
                   let _blendShapeMouth = 0;
       
                   let energyBinMale = new Float32Array(_voiceBoundingFrequencies.length);
       
                   for ( let m = 0 ; m < _voiceBoundingFrequencies.length -1 ; m++){
                       for ( let j = _indicesFrequencyMale[m]; j<= _indicesFrequencyMale[m+1]; j++) {
                           if(_stPSD[j] >0){
                               energyBinMale[m]+= _stPSD[j] ; 	
                           }
                       }
       
                       energyBinMale[m] /= (_indicesFrequencyMale[m+1] -_indicesFrequencyMale[m] ); 
                   }
       
                   if( energyBinMale[1] > 0.2 ) {
                       _blendShapeKiss = 1 -2*energyBinMale[2] ;
                   }else{
                       _blendShapeKiss = ( 1-2*energyBinMale[2])*5*energyBinMale[1];
                   }
       
                   _blendShapeLips = 3*energyBinMale[3];
                   _blendShapeMouth = 0.85*(energyBinMale[1]-energyBinMale[3]);
       
                   let _blendShapes = {
                       blendShapeKiss:_blendShapeKiss,
                       blendShapeLips:_blendShapeLips,
                       blendShapeMouth:_blendShapeMouth
                   }
                //    console.log('process ',_blendShapeMouth)
                   S51WebGLSDK.setJWAOpenValue(_blendShapeMouth)
                //    EventBus.$emit(BUS_EVENT.ADD_LOG,_blendShapeMouth)
               }	

               _this._node.connect(_this.audioCtx.destination);
               _this.audioCtxPlaying=true
               _this._source.start(0,startSec ? startSec :0);
               _this._source.onended = ()=>{
                    console.log('播放结束 111')
                    _this.audioCtxPlaying=false
                    _this._node.onaudioprocess=null
               }
               
            },err => {
                console.log("Error with decoding audio data:" + err);
                reject(err);
            });
               
       },err => {
               console.log("Error with decoding audio data:" + err);
               reject(err);
       });
    }
}

export default new AudioQueue()
export const AudioDriveType ={
    TYPE_2D:0,
    TYPE_3D:1
}


// WEBPACK FOOTER //
// ./src/S51AudioPlayer/index.js